import Vue from 'vue';
import Card from './Card';

Vue.component(Card.name, Card);

export default {
  Card,
};
